import { createDashboardReduxModule } from 'utils/reduxDashboardModuleCreator'

export const urgentUnclassifiedIncidentsRedux = createDashboardReduxModule({
  name: 'URGENT_UNCLASSIFIED_INCIDENTS_WIDGET',
  path: 'dashboard/home/urgentUnclassifiedIncidents',
})
export const SET_END_USER_FILTER = 'SET_END_USER_FILTER'

// `dashboard` is injected only while a Dashboard route is mounted and dropped
// again once another route takes over; in-flight subscriptions/epics can
// still read state in that window, so slice access must be null-safe (see
// AwarenessCenter/Campaigns/selectors.js precedent).
export const selectEndUserFilter = (state) =>
  state.dashboard?.home?.urgentUnclassifiedIncidents?.endUserFilter ?? false
